import { useEffect, useRef } from 'react';

export function usePrevious<T>(value: T, initial?: T) {
  const ref = useRef(initial);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}
